<template>
    <div class="multi-calendar">
        <div class="input-wrapper" @click="inputFocus">
            <input class="multi-date-input" :placeholder="inputPlaceHolder" v-model="inputValue" />
        </div>
        <CalendarPopup v-if="showPopup" @monthSwitch="monthSwitch" :style="popupStyle">
            <CalendarMonth
                class="calendar-pre"
                :monthDate="preMonthDate"
                @dateClick="preDateClickHandler"
                :selectedRange="selectedRange"
                :disableRanges="disabledRanges"
            />
            <CalendarMonth
                class="calendar-next"
                :monthDate="nextMonthDate"
                @dateClick="nextDateClickHandler"
                :selectedRange="selectedRange"
                :disableRanges="disabledRanges"
            />
        </CalendarPopup>
    </div>
</template>

<script>
import CalendarPopup from "./CalendarPopup";
import CalendarMonth from "./CalendarMonth";

export default {
    name: "MultiCalendar",
    components: {
        CalendarPopup,
        CalendarMonth
    },
    // value: Date || Date Array, disableRanges: [{start:Date, end:Date},...], ...
    props: ["value", "placeHolder", "dateFormat", "disableRanges", "isSingle", "position"],
    data() {
        return {
            inputPlaceHolder: this.placeHolder || "YYYY/MM/DD-YYYY/MM/DD",
            inputValue: this.getDisplayValue(this.value),
            showPopup: false,
            selectedRange: this.getSelectedRange(this.value),
            disabledRanges: this.getDisabledRanges(),
            preMonthDate: this.getPreMonthDate(),
            nextMonthDate: this.getNextMonthDate(),
            selectedValues: []
        };
    },
    computed: {
        popupStyle() {
            if (this.position === "left") {
                return {
                    right: "auto",
                    left: 0
                };
            } else if (this.position === "leftTop") {
                return {
                    right: 0,
                    bottom: "41px",
                    top: "auto"
                };
            } else if (this.position === "rightTop") {
                return {
                    right: "auto",
                    left: 0,
                    bottom: "41px",
                    top: "auto"
                };
            }

            return {};
        }
    },
    watch: {
        value(newVal) {
            this.inputValue = this.getDisplayValue(newVal);
            this.selectedRange = this.getSelectedRange(newVal);
            this.preMonthDate = this.getPreMonthDate();
            this.nextMonthDate = this.getNextMonthDate();
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        inputFocus() {
            this.showPopup = true;
        },
        hidePopup() {
            this.selectedValues = [];
            this.showPopup = false;
        },
        preDateClickHandler(date) {
            this.dateClickHandler(date);
        },
        nextDateClickHandler(date) {
            this.dateClickHandler(date);
        },
        dateClickHandler(date) {
            this.selectedValues.push(date);

            if (this.isSingle) {
                this.handlerSingleSelect();
            } else {
                this.handlerRangeSelect();
            }
        },
        handlerSingleSelect() {
            this.$emit("dateSelect", this.selectedValues[0]);

            this.inputValue = this.getDisplayValue(this.selectedValues[0]);
            this.selectedRange = this.getSelectedRange(this.selectedValues[0]);
            this.hidePopup();
            return;
        },
        handlerRangeSelect() {
            if (this.selectedValues.length === 2) {
                let isReversed =
                    this.zhiji.dateFormat(this.selectedValues[0], "YYYYMMDD") > this.zhiji.dateFormat(this.selectedValues[1], "YYYYMMDD");
                isReversed && this.selectedValues.reverse();
                this.$emit("dateSelect", this.selectedValues);

                this.inputValue = this.getDisplayValue(this.selectedValues);
                this.selectedRange = this.getSelectedRange(this.selectedValues);
                this.hidePopup();
                return;
            }

            this.selectedRange = this.getSelectedRange(this.selectedValues[0]);
        },
        getFormat() {
            return this.dateFormat || "YYYY-MM-DD";
        },
        getDisplayValue(value) {
            if (!value) {
                return "";
            }

            if (value instanceof Array && value.length) {
                return this.zhiji.dateFormat(value[0], this.getFormat()) + "-" + this.zhiji.dateFormat(value[1], this.getFormat());
            }

            return this.zhiji.dateFormat(value, this.getFormat());
        },
        getPreMonthDate() {
            if (this.value && this.value.length != null) {
                return this.value.length ? this.value[0] : new Date();
            }

            return this.value || new Date();
        },
        getNextMonthDate() {
            let preMonthDate = this.preMonthDate || this.getPreMonthDate();

            let nextMonth = new Date(preMonthDate.getTime());
            nextMonth.setMonth(nextMonth.getMonth() + 1);

            return nextMonth;
        },
        getSelectedRange(value) {
            let ret = {};
            if (value && value.length != null) {
                ret.start = value.length ? value[0] : null;
                ret.end = value.length > 1 ? value[1] : null;
            } else if (value) {
                ret.start = value;
                ret.end = value;
            }

            return ret;
        },
        getDisabledRanges() {
            if (this.disableRanges) {
                return this.disableRanges;
            }

            return null;
        },
        monthSwitch(direct) {
            let newNextMonthDate;
            let newPreMonthDate;

            if (direct == "pre") {
                newNextMonthDate = this.preMonthDate;
                newPreMonthDate = new Date(this.preMonthDate.getTime());
                newPreMonthDate.setDate(1);
                newPreMonthDate = new Date(newPreMonthDate.getTime() - 24 * 60 * 60 * 1000);
            } else {
                newPreMonthDate = this.nextMonthDate;
                newNextMonthDate = new Date(newPreMonthDate.getTime());
                newNextMonthDate.setMonth(newNextMonthDate.getMonth() + 1);
            }

            this.preMonthDate = newPreMonthDate;
            this.nextMonthDate = newNextMonthDate;
        },
        windowClick(event) {
            if (this.showPopup && this.zhiji.isClickOuter(event, "multi-calendar")) {
                this.hidePopup();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.multi-calendar {
    width: 240px;
    position: relative;

    .input-wrapper {
        width: 100%;
        position: relative;

        &:after {
            position: absolute;
            right: 12px;
            top: 7px;
            content: "";
            width: 18px;
            height: 17px;
            background: url($zhijiStaticImagePath+"overview-spr.png") no-repeat;
            background-position: -302px 0;
        }
    }

    .multi-date-input {
        padding: 7px 10px 7px 8px;
        border-radius: 4px;
        border: 1px solid #d8e4f0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background: #fff;
        width: 100%;

        &:after {
            position: absolute;
            right: 12px;
            top: 7px;
            content: "";
            width: 18px;
            height: 17px;
            background: url($zhijiStaticImagePath+"home/apply-form-spr.png") no-repeat;
            background-position: -41px -24px;
        }
    }

    .calendar-next {
        width: 260px;
        padding-left: 0;
    }
}
</style>
